import React from "react";
import {observer} from "mobx-react-lite";
import {Button} from "@mui/material";
import {useStores} from "../../../stores";
import {ChevronRight} from "@mui/icons-material";
import {useLocation, useNavigate} from "react-router";
import {generateHomePath} from "../../../routing/routing.utils";
import {SupplierNormalizationState} from "./SupplierNormalization.classes";

export const SupplierNormalizationApplyStep: React.FC = observer(() => {
    const {rootAppStore, p, bagStore, supplierNormalizationStore, cmpStore} = useStores();
    const bagId = bagStore.bagId;
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <section className="page-item step">
            <div className="text-center page-item-actions">
                <Button
                    variant="outlined"
                    color="primary"
                    endIcon={<ChevronRight/>}
                    onClick={() => {
                        navigate(generateHomePath(location, {id: String(bagId)}, rootAppStore.app));
                        setTimeout(() => {
                            supplierNormalizationStore.goToState(SupplierNormalizationState.START);
                        }, 100)
                    }}>
                    {p.p.skipAiSupplierNormalizationModel ? 'To dashboard' : 'Back to dashboard'}
                </Button>
            </div>
        </section>
    );
})
